// Initialize Swiper
var swiper = new Swiper("[swiper_scale_active]", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  speed: 1400,
  breakpoints: {
    640: {
      slidesPerView: 2.5,
    },
    1024: {
      slidesPerView: 3,
    },
  },
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 1800,
    disableOnInteraction: false,
  },
  effect: "creative",
  creativeEffect: {
    limitProgress: 10,
    prev: {
      shadow: false,
      opacity: 1,
      scale: 0.75,
      /* translate(<length-percentage> , <length-percentage>?)*/
      translate: ["-95%", 0, 0],
    },
    next: {
      shadow: false,
      opacity: 1,
      scale: 0.75,
      translate: ["95%", 0, 0],
    },
  },
  slideToClickedSlide: true,
  spaceBetween: 10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
swiper.slideNext(0);
swiper.on("slideChange", function () {
  console.log("slide changed");
  var boxes = document.querySelectorAll(".swiper-slide img");
  boxes.forEach((box) => {
    box.addEventListener("click", function handleClick(event) {
      console.log("box clicked", event);
    });
  });
});
